import MarsRover from "../components/MarsRover";

const MarsRoverPage = () => {
  return (
    <div className="container mx-auto">
      <MarsRover />
    </div>
  );
};

export default MarsRoverPage;
